import { QueryClient } from '@tanstack/react-query';

// One shared QueryClient for the whole app. Defaults tuned for the
// dossier-hydration pattern described in docs/decisions.md (D-016, forthcoming):
// when a panel selects an entity, every other linked panel reads the dossier
// from cache rather than re-fetching it.
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // Keep entity dossiers warm for 60s — long enough that scrolling
        // through 10 candidates doesn't re-fetch each one, short enough that
        // a fresh return to a target sees recently-updated signal scores.
        staleTime: 60_000,
        // Retain in cache for 5 minutes after the last subscriber leaves.
        gcTime: 5 * 60_000,
        retry: 1,
        refetchOnWindowFocus: false,
      },
    },
  });
}

// Query key conventions — namespaced by domain so we can invalidate
// surgically (e.g., invalidate all entity dossiers after a re-ingest).
export const queryKeys = {
  markets: () => ['markets'] as const,
  entitiesList: (query: object) => ['entities', 'list', query] as const,
  entity: (id: string) => ['entities', id] as const,
  entityFinancials: (id: string) => ['entities', id, 'financials'] as const,
};
